import React, { Component } from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as faIcons from '@fortawesome/free-solid-svg-icons';
import exact from 'prop-types-exact';
import { transformHTML } from '../../../helpers/transformHTML';
import Button from '../../../common/button/Button';

// NOTE: currently only solid fonteawesome icons are possible!

const cacaAoTesouroLogo = '/imgHunt/cacaAoTesouroLogo.png';
const ondas = '/imgHunt/ondas.png';
const boozeImages = [
    '/imgHunt/booze5.png',
    '/imgHunt/booze4.png',
    '/imgHunt/booze3.png',
    '/imgHunt/booze2.png',
    '/imgHunt/booze1.png',
];
const navegue = '/imgHunt/navegue.png';
const regulamento = '/imgHunt/regulamento.png';

// @TODO using the _setContentToShow in the onClick handler as done below is bad for performance (see https://stackoverflow.com/a/29810951)
// as outlined in the linked answer, we should create a subcomponent that recieves the onClick function and the corresponding value via props...
// Disabeling the lint rule for now:
/* eslint-disable react/jsx-no-bind */

class CacaAoTesouro extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keepMenuStop: false,
            contentToShow: 'start',
            currentTooltip: false,
        };

        this._handlingRightMenu = this._handlingRightMenu.bind(this);
    }

    componentDidMount() {
        // go to top
        animateScrollTo(0, { speed: 700 });

        const isMobile = this.props.breakpoint.isSmall || this.props.breakpoint.isExtraSmall;

        // bind event scroll
        if (window.addEventListener && !isMobile) { // For all major browsers, except IE 8 and earlier
            window.addEventListener('scroll', this._handlingRightMenu);
        } else if (window.attachEvent && !isMobile) { // For IE 8 and earlier versions
            window.attachEvent('scroll', this._handlingRightMenu);
        }

        // Get active hunt and quantity buzios
        this.props.checkInfoActiveHunt();
    }

    _setContentToShow(typeContent) {
        // go to top
        animateScrollTo(530, { speed: 700 });

        this.setState({ contentToShow: typeContent });
    }

    _setCurrentTooltip(index) {
        this.setState((prevState) => ({
            currentTooltip: index === prevState.currentTooltip ? false : index,
        }));
    }

    _showPrizes() {
        const prizes = this.props.prizesInfo;

        return prizes.map((item, index) => {
            const visible = index === this.state.currentTooltip;

            return (
                <div className="prize" key={item.prizeName}>
                    <div className="tooltip-block">
                        <FontAwesomeIcon icon={faIcons.faInfoCircle} className="tooltip-icon" width="16" onClick={this._setCurrentTooltip.bind(this, index)} />
                    </div>
                    <span className={`tooltip-description${visible ? ' visible' : ''}`}>
                        {item.prizeDescription}
                    </span>
                    <div className="totalNumber">
                        <div>
                            {item.numberTotalPrize}
                            x
                        </div>
                    </div>
                    <div className="prizeIcon">
                        <FontAwesomeIcon icon={faIcons[item.prizeIcon]} className="iconPrize" width="16" />
                    </div>
                    <div className="description">
                        {item.prizeName}
                    </div>
                </div>
            );
        });
    }

    _handlingRightMenu() {
        const
            footer = document.querySelector('.global-footer');
        const rightMenu = document.querySelector('.menu-right');
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        const pageHeight = document.documentElement.offsetHeight;
        const footerHeight = footer && footer.offsetHeight;
        const rightMenuHeight = rightMenu && rightMenu.offsetHeight;
        const staticValue = 200;
        const maxScroll = pageHeight - (footerHeight + rightMenuHeight + staticValue);
        const keepMenuStop = this.state.keepMenuStop;


        if (scrollTop > maxScroll && keepMenuStop === false) {
            this.setState({
                keepMenuStop: true,
            });
        } else if (scrollTop < maxScroll && keepMenuStop === true) {
            this.setState({
                keepMenuStop: false,
            });
        }
    }

    render() {
        const numPrizesAvailable = this.props.totalPrizes - this.props.totalPrizesWon;
        const totalPrizes = this.props.totalPrizes;
        let boozeIndex = 0;

        if (numPrizesAvailable && totalPrizes) {
            // only calculate the percentage  if there are prizes to win
            const boozePercentage = (numPrizesAvailable / totalPrizes) * 100;

            boozeIndex = Math.ceil(boozePercentage / 25);
            // 100 - 76: 4
            // 75 - 51: 3
            // 50 - 26: 2
            // 25 - 1: 1
            // 0: 0
        }

        const boozeImage = boozeImages[boozeIndex];

        const activeHunt = this.props.prizesInfo && this.props.prizesInfo.length > 0;

        return (
            <section className="hunt-page">
                <header>
                    <h1 className="logo">
                        <img src={cacaAoTesouroLogo} alt="Caça ao tesouro da Antena 1" />
                    </h1>
                    <div className="ondas">
                        <img src={ondas} alt="ondas" />
                    </div>
                </header>
                <nav className={`menu-right ${this.state.keepMenuStop && 'menu-right-stop'}`}>
                    <ul>
                        <li className={` ${this.state.contentToShow === 'start' && 'activeButton'}`}>
                            <Button
                                title="Como funciona"
                                onClick={this._setContentToShow.bind(this, 'start')}
                            >
                                <img src={navegue} alt="Navegue" className="btn-figure" />
                                <span className="btn-caption">
                                    Inicio
                                </span>
                            </Button>
                        </li>
                        <li className={` ${this.state.contentToShow === 'regulation' && 'activeButton'}`}>
                            <Button
                                title="Ver Regulamento"
                                onClick={this._setContentToShow.bind(this, 'regulation')}
                            >
                                <img src={regulamento} alt="Regulamento" className="btn-figure" />
                                <span className="btn-caption">
                                    Regulamento
                                </span>
                            </Button>
                        </li>
                        <li className={` ${this.state.contentToShow === 'prizes' && 'activeButton'}`}>
                            <Button
                                title="Prêmios restantes / Total"
                                onClick={this._setContentToShow.bind(this, 'prizes')}
                            >
                                <img className="btn-figure booze" src={boozeImage} alt="Booze" />
                                <span className="btn-caption">
                                    Premios
                                    {' '}
                                    <br />
                                    {' '}
                                    {numPrizesAvailable}
                                    /
                                    {totalPrizes}
                                </span>
                            </Button>
                        </li>
                    </ul>
                </nav>
                <div id="hunt-page-content" className="hunt-page-content">
                    {
                        this.state.contentToShow === 'start' ?
                            <div>
                                <h2>Como começar a caçar?</h2>
                                <p>
                                    A caça ao tesouro começa aqui.
                                    <br />
                                    Cadastre-se, faça o login no site da Antena 1 e navegue normalmente,
                                    quando surgir um baú na sua tela, você é premiado!
                                    <br />
                                    Confira os
                                    {' '}
                                    <Button title="Veja os prêmios" onClick={this._setContentToShow.bind(this, 'prizes')}>prêmios</Button>
                                    {' '}
                                    disponíveis.
                                </p>
                                <br />
                                <h2>Passo a passo</h2>
                                <p>
                                    1: Faça o login ou cadastre-se e preencha TODOS os dados.
                                    <br />
                                    2: Leia o
                                    {' '}
                                    <Button title="Veja o regulamento" onClick={this._setContentToShow.bind(this, 'regulation')}>regulamento</Button>
                                    .
                                    <br />
                                    3: Dê play no
                                    {' '}
                                    <Button className="TextLink" to="/ouvir-radio-online" title="Ir para ouvir rádio online">ouvir rádio online</Button>
                                    {' '}
                                    e navegue pela página até encontrar o seu baú.
                                    <br />
                                </p>
                                <br />
                                <div className="init-text">INICIE SUA CAÇA AO TESOURO AGORA!</div>
                                <div className="buttonStart">
                                    {!this.props.userLogged || !this.props.registrationComplete ?
                                        <Button onClick={this.props.setProfileModalState.bind(this, true)} title="Iniciar a caça" className="modal-button-start">
                                            INICIAR
                                        </Button>
                                        :
                                        <Button to="/ouvir-radio-online" title="Iniciar a caça" className="modal-button-start">
                                            INICIAR
                                        </Button>}
                                </div>
                            </div>
                            : this.state.contentToShow === 'regulation' ?
                                <div>
                                    <h2>Regulamento</h2>
                                    {
                                        activeHunt
                                            ? transformHTML(this.props.huntRegulation)
                                            : <p>Fique antenado e não perca a PRÓXIMA caça ao tesouro!</p>
                                    }
                                </div>
                                :
                                <div className="prizes-block">
                                    <h2>Veja os prêmios que você pode encontrar nessa temporada</h2>
                                    {
                                        activeHunt
                                            ? this._showPrizes()
                                            : <p>Não há prêmios no momento</p>
                                    }
                                </div>
                    }
                </div>
            </section>
        );
    }
}

CacaAoTesouro.propTypes = exact({
    checkInfoActiveHunt: PropTypes.func,
    totalPrizes: PropTypes.number.isRequired,
    totalPrizesWon: PropTypes.number.isRequired,
    huntRegulation: PropTypes.string,
    prizesInfo: PropTypes.array,
    userLogged: PropTypes.bool,
    registrationComplete: PropTypes.bool,
    setProfileModalState: PropTypes.func,
    breakpoint: PropTypes.object,
});


export default CacaAoTesouro;


// Regulation (for copy pasting into the database)
/*
<p>1. Para participar, qualquer pessoa poderá se inscrever, devendo ter cadastro completo no site www.antena1.com.br.</p>
<p>2. O participante deve possuir idade mínima de 18 anos.</p>
<p>3. Esta promoção é válida para todo Brasil, porém possui alguns prêmios válidos para regiões específicas.</p>
<p>4. Será contemplado o participante que, na ocasião de sua navegação no site, visualizar o “Baú do Tesouro” na tela dizendo que ele foi o vencedor. É necessário abrir o baú (clicando nele) dentro de até uma hora.</p>
<p>5. A Antena 1 não se responsabiliza por perda/furto do prêmio entregue ao vencedor, e em hipótese alguma o mesmo poderá ser revertido em dinheiro. </p>
<p>6. Após clicar no baú, será enviado um e-mail com mais informações sobre o prêmio. O vencedor terá 2 dias para responder nosso contato, caso contrário o prêmio será passado para outro participante.</p>
<p>7. Caso a retirada do prêmio seja física, a Antena 1 se reserva ao direito de NÃO entregar à pessoa que não apresenta o documento de identidade válido. </p>
<p>8. Não poderão participar da promoção funcionários das empresas direta ou indiretamente envolvidas.</p>
<p>9. O vencedor autoriza, desde já, o uso de sua imagem e voz e a divulgação em fotos, cartazes, filmes e/ou spots, em qualquer tipo de mídia e peças promocionais, para a divulgação da conquista de prêmios e concorda em ceder os direitos autorais sobre a foto enviada em quaisquer outros direitos eventualmente existentes, para que possa fazer uso desse material livremente e da forma que lhe aprouver, sem qualquer ônus, aos organizadores desta promoção.</p>
<p>10. Esta promoção da Antena 1 é de caráter exclusivamente artístico-cultural. A distribuição de prêmios é gratuita, não obrigando aos participantes a nenhum tipo de compra, nem agora, nem em ocasiões futuras, de acordo com o inciso II, do artigo 3º da Lei nº 5768/71, regulamentada pelo Decreto nº 70951/72.</p>
<p>11. O Ganhador deve respeitar o prazo de validade de cada prêmio. Não é de responsabilidade da Antena 1, retificá-lo sobre a data limite, devendo o próprio ganhador se atentar a ela.</p>
<p>12. Não haverá troca ou mudança de prêmio em hipótese alguma, a validade não será prorrogada.</p>
<p>13. A participação na promoção implica na aceitação total dos itens deste regulamento, e o seu prêmio não poderá ser revertido em nenhuma espécie de valor, perdendo sua validade se não retirado.</p>
<p>14. Os prêmios poderão ter condições adicionais e particulares que deverão ser verificados.</p>
<p>15. Atenção: Confira o regulamento e a validade de cada prêmio.</p>
*/
